export default __webpack_public_path__ + "static/media/Ico-inprogress.023bd9ca.svg";